import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetSearch } from "../../Store/SearchReducer/action";

export const useEntitySearch = ({
  entity,
  searchState,
  getInitialState = () => ({}),
  fetchAction,
  preserveSearch,
  isReady,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isReady) return;

    // KEY: even if preserveSearch=true, check if searchState has real data
    // Hard refresh wipes Redux → searchState empty → use initial
    const isSearchStateEmpty =
      !searchState || Object.keys(searchState).length === 0;

    const initialSearch =
      preserveSearch && !isSearchStateEmpty
        ? searchState       // ← user came back, keep their filters
        : getInitialState(); // ← fresh load / hard refresh / new tab

    if (!preserveSearch || isSearchStateEmpty) {
      dispatch(resetSearch(entity, initialSearch));
    }

    dispatch(fetchAction(initialSearch));

  }, [isReady]);
};